// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"NotFound_Wrapper__2ch6H","Heading":"NotFound_Heading__1mLti","Subheading":"NotFound_Subheading__2lYrG"};